import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import ServicePlanContent from './index';
import '~/styles/main.scss';

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;

global.ServicePlanContent = ServicePlanContent;
// Alias so `Html.React(content.GetType().Name, data)` from
// `portableComponent.cshtml` (which emits the C# type name `"ServicePlan"`)
// finds the same component. Mirrors the dispatch the legacy macro did
// directly with `Html.React("ServicePlanContent", ...)`.
global.ServicePlan = ServicePlanContent;
